export const frontendParams = {
  url: `${window.location.protocol}//${window.location.host}`
}
